import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchAppVersionsList,
  editAppVersion,
} from "src/services/appVersion.service";

export const doFetchAppVersionList = createAsyncThunk(
  "appVersion/fetchList",
  async () => {
    try {
      const response: any = await fetchAppVersionsList();
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch app versions list";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

export const doEditAppVersion = createAsyncThunk(
  "appVersion/edit",
  async (params: {
    id: number;
    latestVersion: number;
    minVersion: number;
  }) => {
    try {
      const response: any = await editAppVersion(params.id, {
        latestVersion: params.latestVersion,
        minVersion: params.minVersion,
      });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to edit app version";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);
